import type {
  GetCustomerListNameIdQuery,
  GetCustomerListNameIdQueryVariables,
  GetDeviceListNameIdQuery,
  GetDeviceListNameIdQueryVariables,
  GetLayoutListNameIdQuery,
  GetLayoutListNameIdQueryVariables,
  GetLocationListNameIdQuery,
  GetLocationListNameIdQueryVariables,
  GetManagementServiceListNameIdQuery,
  GetManagementServiceListNameIdQueryVariables,
  GetOrganizationListNameIdQuery,
  GetOrganizationListNameIdQueryVariables,
  GetPostListNameIdQuery,
  GetPostListNameIdQueryVariables,
  GetProfileListNameIdQuery,
  GetProfileListNameIdQueryVariables,
  GetServiceListNameIdQuery,
  GetServiceListNameIdQueryVariables,
  GetTagListNameIdQuery,
  GetTagListNameIdQueryVariables,
} from "@package/ui-gql/index-data-access";

export type ItemSelectQuery =
  | GetCustomerListNameIdQuery
  | GetDeviceListNameIdQuery
  | GetLayoutListNameIdQuery
  | GetLocationListNameIdQuery
  | GetManagementServiceListNameIdQuery
  | GetOrganizationListNameIdQuery
  | GetPostListNameIdQuery
  | GetProfileListNameIdQuery
  | GetServiceListNameIdQuery
  | GetTagListNameIdQuery;

export type ItemSelectQueryVariables =
  | GetCustomerListNameIdQueryVariables
  | GetDeviceListNameIdQueryVariables
  | GetLayoutListNameIdQueryVariables
  | GetLocationListNameIdQueryVariables
  | GetManagementServiceListNameIdQueryVariables
  | GetOrganizationListNameIdQueryVariables
  | GetPostListNameIdQueryVariables
  | GetProfileListNameIdQueryVariables
  | GetServiceListNameIdQueryVariables
  | GetTagListNameIdQueryVariables;

export function getDisplayForDocumentItem<Q extends ItemSelectQuery>(
  item?: Q["items"][0],
  fallback?: string,
): string | null | undefined {
  switch (item?.__typename) {
    case "Customer":
    case "Device":
    case "Layout":
    case "Location":
    case "OrganizationModel":
    case "ProfileModel":
    case "Service":
      return item?.name;
    case "Post":
    case "Tag":
      return item?.title;
    default:
      return item?.id ?? fallback ?? "Select an Item";
  }
}
